import { Box, Stack, Switch, Typography } from '@mui/material';
import { ReactElement, useId } from 'react';
import { useTranslation } from 'react-i18next';
import { InfoIcon } from '../../../assets/icons';

export interface PersonalSpaceSwitchProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  switchTitle: string;
  switchInfoAllowed: string;
  switchInfoForbidden: string;
  dataTestId?: string;
}

export function PersonalSpaceSwitch({
  checked,
  onChange,
  disabled,
  switchTitle,
  switchInfoAllowed,
  switchInfoForbidden,
  dataTestId,
}: Readonly<PersonalSpaceSwitchProps>): ReactElement<PersonalSpaceSwitchProps> {
  const [t] = useTranslation();
  const id = useId();

  return (
    <div>
      <Typography variant="body3" id={id}>
        {switchTitle}
      </Typography>
      <Stack direction="row" spacing={1} alignItems="center" className="mt-6">
        <Typography variant="body2" className="lowercase">
          {t('SHARED_NO')}
        </Typography>
        <Switch
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          inputProps={{ 'aria-labelledby': id }}
          data-testid={dataTestId}
        />
        <Typography variant="body2" className="lowercase">
          {t('SHARED_YES')}
        </Typography>
      </Stack>
      <Box className="mt-6 flex items-center">
        <InfoIcon className="min-w-fit" />
        <Typography variant="body2" className="ml-2 max-w-md">
          {checked ? switchInfoAllowed : switchInfoForbidden}
        </Typography>
      </Box>
    </div>
  );
}
